import type { Metadata as DocservFile } from '@b-stock/docserv-api-client'

import appConfig from '@config/config'
import { get, post } from '@helpers/xhr'

const url = appConfig.api.docserv.default

const buildForm = (doc: Blob) => {
  const formData = new FormData()
  formData.append('doc', doc)
  formData.append('type', doc.type)
  return formData
}

export default {
  create: (doc: Blob) =>
    post<DocservFile>(url, buildForm(doc), {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  downloadByDocId: (id: string) =>
    get<Blob>(`${url}/${id}`, undefined, { responseType: 'blob' }),
}
